import {
  Box,
  Button,
  Container,
  Flex,
  FormLabel,
  Input,
  Text,
  Icon,
  createIcon,
  Img,
  Modal,
  useToast,
  ModalHeader,ModalFooter,
  Spinner,
  Textarea,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import {
  Center,
  Checkbox,
  Divider,
  HStack,
  Heading,
  IconButton,
  InputGroup,
  InputRightElement,
  VStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ViewIcon, ViewOffIcon, ChevronDownIcon, ArrowBackIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import sylvr_logo from "../../assets/images/sylvr-logo-register.png";
import { Tooltip } from '@chakra-ui/react';

import ProductsDropdown from "../../components/ProductsDropdown";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SectorCategoriesDropdown from "../../components/SectorCategoriesDropdown";
import { emailCheck, userRegister } from "../../actions/user/userActions";
import { getSectorsCategories } from "../../actions/sector/sectorActions";
import { getSectorCategoryProductsApi } from "../../api/productApi";

import FoodKindredProductsIcon from "../../components/Icons/FoodKindredProductsIcon";
import FabricatedMetalProductsIcon from "../../components/Icons/FabricatedMetalProductsIcon";
import PaperAlliedProductsIcon from "../../components/Icons/PaperAlliedProductsIcon";
import IndustrialCommercialMachineryComputerEquipmentIcon from "../../components/Icons/IndustrialCommercialMachineryComputerEquipmentIcon";
import TextileMillProductsIcon from "../../components/Icons/TextileMillProductsIcon";
import TransportationEquipmentIcon from "../../components/Icons/TransportationEquipmentIcon";
import ApparelFinishedProductsIcon from "../../components/Icons/ApparelFinishedProductsIcon";
import PrimaryMetalIndustriesIcon from "../../components/Icons/PrimaryMetalIndustriesIcon";
import RubberMiscellaneousPlasticProductsIcon from "../../components/Icons/RubberMiscellaneousPlasticProductsIcon";
import ElectronicEquipmentComponentsIcon from "../../components/Icons/ElectronicEquipmentComponentsIcon";
import { SECTOR_ICONS } from "../../utils/Stringconstant";
import { getSectorCategories, getAllSectors } from "../../actions/sector/sectorActions";
export default function Register(props) {
  const [userType, setUserType] = useState("client");
  const [isSignUp, setIsSignUp] = useState(true);
  const [data, setData] = useState({});
  const navigate = useNavigate();


  const ChartIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M3 3v18h18v-2H5V3H3zm4 10h2v5H7v-5zm4-4h2v9h-2v-9zm4-4h2v13h-2V5z"
      />
    </Icon>
  );

  const CalendarIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M7 10h5v5H7v-5zm6 0h5v5h-5v-5zM3 4h1V2h2v2h10V2h2v2h1a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2zm0 16h18V8H3v12z"
      />
    </Icon>
  );

  const UserIcon = (props) => (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z"
      />
    </Icon>
  );

  const BuildingIcon = createIcon({
    displayName: "BuildingIcon",
    viewBox: "0 0 24 24",
    path: <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />,
  });

  const iconItems = [
    { name: "Food Kindred Products", icon: FoodKindredProductsIcon },
    { name: "Fabricated Metal Products", icon: FabricatedMetalProductsIcon },
    { name: "Paper Allied Products", icon: PaperAlliedProductsIcon },
    { name: "Industrial Machinery", icon: IndustrialCommercialMachineryComputerEquipmentIcon },
    { name: "Textile Mill Products", icon: TextileMillProductsIcon },
    { name: "Transportation Equipment", icon: TransportationEquipmentIcon },
    { name: "Appare lFinished Products", icon: ApparelFinishedProductsIcon },
    { name: "Primary Metal Industries", icon: PrimaryMetalIndustriesIcon },
    { name: "Rubber Plastic Products", icon: RubberMiscellaneousPlasticProductsIcon },
    { name: "Electronic Components", icon: ElectronicEquipmentComponentsIcon },
  ];

 const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        minH="100vh"
      >
        {/* Left Section - Client */}
        {userType === "client" && (
          <Box
            bg="#30D5C8"
            color="white"
            w={{ base: "100%", md: "50%" }}
            px={{ base: 4, md: 10 }}
            py={0}
          >
            <Box textAlign="center" pt={0}>
              <Link to="https://beta.sylvr.co.in">
                <Img
                  src={sylvr_logo}
                  width="150px"
                  mx="auto"
                  filter="brightness(0) invert(1)"
                />
              </Link>
            </Box>


            <Text fontSize="2xl" fontWeight="bold" mb={4} textAlign="center">
              Achieve business goals with directional insights
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={6}>
              <Box bg="white" color="black" p={4} borderRadius="md">
                <ChartIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Track relevant metrics</Text>
                <Text fontSize="sm">
                  Dive deep into EBITDA%, ROE, Revenue Growth, Materials% & more
                </Text>
              </Box>

              <Box bg="white" color="black" p={4} borderRadius="md">
                <CalendarIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Summarize SMM activity</Text>
                <Text fontSize="sm">
                  Explore trends for past 7 years. Our AI assistant will guide you
                </Text>
              </Box>

              <Box bg="white" color="black" p={4} borderRadius="md">
                <UserIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Get personalized expertise</Text>
                <Text fontSize="sm">
                  Expert recommendations adapted to your business trends and
                  diagnostics
                </Text>
              </Box>

              <Box bg="white" color="black" p={4} borderRadius="md">
                <BuildingIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Connect with suppliers</Text>
                <Text fontSize="sm">
                  Profile partnerships based on your vision alignment
                </Text>
              </Box>
            </SimpleGrid>

            <Text fontSize="sm" mb={2} color={"black"} fontWeight={"bold"}>
              Industries Analysed
            </Text>
            <Flex gap={2} flexWrap="wrap" mb={4}>
              {iconItems.map(({ name, icon: IconComponent }, i) => (
                <Tooltip key={i} label={name} hasArrow>
                  <Box
                    fontSize="20px"
                    bg="white"
                    color="black"
                    px={3}
                    py={2}
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    cursor="pointer"
                  >
                    <IconComponent color="#30d5c8" />
                  </Box>
                </Tooltip>
              ))}
            </Flex>

            <Flex direction="column" align="center" justify="center" mt={6}>
         <Button
        bg="#FFAA00"
        color="#162421"
        borderRadius="10px"
        px={130}
        fontWeight="bold"
        onClick={onOpen}
        leftIcon={
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "2px solid #162421",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "transparent",
            }}
          >
            <Icon viewBox="0 0 20 20" color="#162421">
              <path fill="currentColor" d="M6 4l10 6-10 6V4z" />
            </Icon>
          </div>
        }
      >
        View A Demo
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
        <ModalOverlay bg="blackAlpha.900" />
        <ModalContent bg="black" p={0} maxW="100vw" maxH="100vh">
          <ModalCloseButton color="white" size="lg" zIndex={2} />
          <ModalBody
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={0}
            height="100vh"
            width="100vw"
          >
            <div
              style={{
                position: "relative",
                width: "80vw",
                height: "45vw", // Keeps 16:9 aspect ratio
                maxHeight: "90vh",
              }}
            >
              <iframe
                src="https://embed.app.guidde.com/playbooks/r3ra7qMbEVNNcBdMwBtENx?mode=videoOnly"
                title="Guidde Demo Video"
                width="100%"
                height="100%"
                style={{
                  border: "none",
                  borderRadius: "12px",
                }}
                allowFullScreen
              ></iframe>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>

              <Text fontSize="xs" mt={2} color="black">
                No credit card required | Cancel anytime
              </Text>
            </Flex>
          </Box>
        )}

        {/* Left section -Experts */}
        {userType === "expert" && (
          <Box
            bg="#30D5C8"
            color="white"
            w={{ base: "100%", md: "50%" }}
            px={{ base: 4, md: 10 }}
            py={0}
          >
            <Box textAlign="center" pt={0}>
              <Link to="https://beta.sylvr.co.in">
                <Img
                  src={sylvr_logo}
                  width="150px"
                  mx="auto"
                  filter="brightness(0) invert(1)"
                />
              </Link>
            </Box>

            <Text fontSize="2xl" fontWeight="bold" mb={4} textAlign="center">
              Collaborate & share your expertise with businesses all over India
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={6}>
              <Box bg="white" color="black" p={4} borderRadius="md">
                <ChartIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Collaborate with SMMs</Text>
                <Text fontSize="sm">
                  Connect with businesses and form trusted relationships
                </Text>
              </Box>

              <Box bg="white" color="black" p={4} borderRadius="md">
                <CalendarIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Share your expertise</Text>
                <Text fontSize="sm">
                  Case studies match you to your client's needs
                </Text>
              </Box>

              {/* Center the last box on 2nd row */}
              <Box
                bg="white"
                color="black"
                p={4}
                borderRadius="md"
                gridColumn={{ base: "auto", md: "span 2" }}
                justifySelf="center"
                maxW="50%"
              >
                <UserIcon boxSize={6} color="#30d5c8" mb={2} />
                <Text fontWeight="semibold">Summarize SMM activity</Text>
                <Text fontSize="sm">
                  Explore trends for past 7 years. Our AI assistant will guide you
                </Text>
              </Box>
            </SimpleGrid>


            <Text fontSize="sm" mb={2} color={"black"} fontWeight={"bold"}>
              Industries Analysed
            </Text>
            <Flex gap={2} flexWrap="wrap" mb={4}>
              {iconItems.map(({ name, icon: IconComponent }, i) => (
                <Tooltip key={i} label={name} hasArrow>
                  <Box
                    fontSize="20px"
                    bg="white"
                    color="black"
                    px={3}
                    py={2}
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    cursor="pointer"
                  >
                    <IconComponent color="#30d5c8" />
                  </Box>
                </Tooltip>
              ))}
            </Flex>

            <Flex direction="column" align="center" justify="center" mt={6}>
              <Button
                bg="#FFAA00"
                color="#162421"
                borderRadius="10px"
                px={130}
                fontWeight="bold"
                leftIcon={
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      border: "2px solid #162421",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "transparent",
                    }}
                  >
                    <Icon viewBox="0 0 20 20" color="#162421">
                      <path fill="currentColor" d="M6 4l10 6-10 6V4z" />
                    </Icon>
                  </div>
                }
              >
                View A Demo
              </Button>
              <Text fontSize="xs" mt={2} color="black">
                No credit card required | Cancel anytime
              </Text>
            </Flex>
          </Box>
        )}


        {/* Right Section - Form Panel */}
        <Box
          w={{ base: "100%", md: "50%" }}
          px={{ base: 4, md: 12 }}
          py={0}
          bg="white"
        >
          <Container p={"10px"}>
            <Flex display={"flex"} justifyContent={"space-between"}>
              <Box>
                <Text
                  textAlign={"left"}
                  mb={1}
                  fontSize={"14px"}
                  textColor={"#4E6565"}
                >
                  Hey there. Glad to have you on board
                </Text>
              </Box>
              <Box>
                <Flex>
                  {/* <Text
                    textAlign={"center"}
                    mb={1}
                    mr={2}
                    fontWeight={400}
                    fontSize={"14px"}
                    color={"#0C543C"}
                  >
                    SignIn 
                  </Text> */}
                  <Text
                    textAlign={"center"}
                    mb={1}
                    fontWeight={600}
                    fontSize={"13px"}
                    color={"#162421"}
                    borderBottom={"2px solid #30D5C8"}
                    _hover={{
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/login")}
                  >
                    Already have an account?Login here
                  </Text>
                </Flex>
              </Box>
            </Flex>

            <Box
              display="flex"
              alignItems="center"
              flexDirection={{ base: "column", md: "row" }}
              m={"5px"}
            >
              <Text
                fontSize={{ base: "14px", md: "16px" }}
                mb={{ base: "3", md: "0" }}
                fontWeight="600"
                mr={{ base: "0", md: "15" }}
              >
                Are you a
              </Text>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Box
                  textAlign="center"
                  padding={{ base: "8px 10px", md: "8px 20px" }}
                  backgroundColor={userType === "client" ? "#30D5C8" : "#fff"}
                  color={userType === "client" ? "#162421" : "#0C543C"}
                  cursor={isSignUp ? "pointer" : "not-allowed"}
                  fontWeight={'600'}
                  fontSize={{ base: "14px", md: "16px" }}
                  borderRadius="8px 0px 0px 8px"
                  border="1px solid #30D5C8"
                  onClick={() => {
                    if (isSignUp) {
                      setUserType("client");
                    }
                  }}
                >
                  SMM
                </Box>
                {/* <Box
                  textAlign="center"
                  color={userType === "agency" ? "#fff" : "#0C543C"}
                  cursor={isSignUp ? "pointer" : "not-allowed"}
                  fontSize={{ base: "14px", md: "16px" }}
                  padding={{ base: "8px 10px", md: "8px 20px" }}
                  backgroundColor={userType === "agency" ? "#0C543C" : "#fff"}
                  border="1px solid #0C543C"
                  onClick={() => {
                    if (isSignUp) {
                      setUserType("agency");
                    }
                  }}
                >
                  Practice
                </Box> */}
                <Box
                  textAlign="center"
                  color={userType === "expert" ? "#000" : "#0C543C"}
                  fontWeight={'600'}
                  cursor={isSignUp ? "pointer" : "not-allowed"}
                  fontSize={{ base: "14px", md: "16px" }}
                  padding={{ base: "8px 10px", md: "8px 20px" }}
                  backgroundColor={userType === "expert" ? "#30D5C8" : "#fff"}
                  borderRadius="0px 8px 8px 0px"
                  border="1px solid #30D5C8"
                  onClick={() => {
                    if (isSignUp) {
                      setUserType("expert");
                    }
                  }}
                >
                  Expert
                </Box>
              </Box>
            </Box>
            <Box
              pt={2}
              fontSize={"16px"}
              textColor={"#162421"}
              fontWeight={600}
            >
              {userType === "client" && (
                <Text textAlign={"center"} mb={1} >
                  Best for SMM Leader or Finance Controller
                </Text>
              )}
              {userType === "expert" && (
                <Text textAlign={"center"} mb={1}>
                  Best for experts who have helped SMMs to grow
                </Text>
              )}
            </Box>
          </Container>
          <Box
            borderRadius="18px"
            marginTop="3px"
            padding={{ base: "5px", md: "2px" }}
          >
            <Container>
              <Box borderRadius={10} boxShadow="lg" borderWidth={1}>
                <VStack
                  w={"100%"}
                  bg={"white"}
                  p={1}
                  spacing={4}
                  borderRadius={10}
                >
                  {isSignUp && (
                    <CommonLoginForm
                      userType={userType}
                      setIsSignUp={setIsSignUp}
                      setData={setData}
                      data={data}
                    />
                  )}
                  {!isSignUp && userType === "client" && (
                    <ClientRegistrationForm
                      userType={userType}
                      setIsSignUp={setIsSignUp}
                      data={data}
                    />
                  )}
                  {!isSignUp && userType === "agency" && (
                    <AgencyRegistrationForm
                      userType={userType}
                      setIsSignUp={setIsSignUp}
                      data={data}
                    />
                  )}
                  {/* {!isSignUp && !isShowCaseStudy && userType === "expert" && (
                    <ExpertRegistrationForm
                      userType={userType}
                      setIsSignUp={setIsSignUp}
                      data={data}
                    />
                  )}
                  {!isSignUp && isShowCaseStudy && userType === "expert" && (
                    <AddCaseStudyForm setOrgFormData={setData} setIsSignUp={setIsSignUp} setIsShowCaseStudy={setIsShowCaseStudy}/>
                  )} */}
                </VStack>
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
}

const CommonLoginForm = ({ userType, setIsSignUp, setData, data }) => {
  console.log("==data", data);
  const [formData, setFormData] = useState({
    mobileno: "",
    full_name: "",
    email: "",
    password: "",
    cnfPswd: "",
    pswd: "",
  });

  const [curretnInputFocous, setCurrentInputFocous] = useState("");
  const [nextClick, setNextClick] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [dataError, setDataError] = useState({
    mobileno: false,
    email: false,
    password: false,
    cnfPswd: false,
    pswd: false,
  });
  const { loading: userLoading, data: userData } = useSelector(
    (state) => state.userReducer
  );

  // const changeHandler = (e) => {
  //   const name = e.target.name;
  //   let value = e.target.value;

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };
  const changeHandler = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    setFormData((prevData) => ({
      ...prevData, // Preserve all existing fields
      [name]: value,
      // Preserve caseStudies array if it exists
      caseStudies: prevData.caseStudies || [],
    }));
  };
  const nextHandler = () => {
    setNextClick(true);
    if (userType === "agency" && formData.mobileno === "") {
      toast.error("Please enter mobile", {
        position: "bottom-center",
        toastId: "pswd-mismatch",
      });
      setCurrentInputFocous("mobileno");
    } else if (formData.email === "" || !emailRegex.test(formData.email)) {
      toast.error("Please enter valid email", {
        position: "bottom-center",
        toastId: "pswd-mismatch",
      });
      setCurrentInputFocous("email");
    } else if (
      formData.pswd &&
      formData.cnfPswd &&
      formData.pswd === formData.cnfPswd
    ) {
      dispatch(emailCheck({ email: formData.email }));
    } else {
      toast.error("Password and confirm password must be same", {
        position: "bottom-center",
        toastId: "pswd-mismatch",
      });
      setCurrentInputFocous("cnfPswd");
    }
  };

  useEffect(() => {
    if (!userLoading && userData && nextClick) {
      if (!userData?.status) {
        setIsSignUp(false);
        // Pass all form data including caseStudies
        setData({
          ...formData, // Include all form fields
          mobileno: formData.mobileno,
          email: formData.email,
          password: formData.pswd,
          caseStudies: formData.caseStudies || [],
        });
      }
    }
  }, [userLoading]);

  useEffect(() => {
    if (!userLoading && userData && nextClick) {
      if (!userData?.status) {
        setIsSignUp(false);
        setData({
          mobileno: formData.mobileno,
          email: formData.email,
          password: formData.pswd,
        });
      }
    }
  }, [userLoading]);
  return (
    <>

      <Flex pt={2}>

        <Text fontWeight={700} fontSize={14} color={"#162421"} textTransform={"uppercase"}>
          Register to discover the smart suite of future financial tools
        </Text>
      </Flex>
      <Box w={"100%"} p="5px 15px">
        {userType === "agency" && (
          <Box mb={4}>
            <FormLabel
              fontWeight={400}
              fontSize={"13px"}
              textColor={"#0C543C"}
              mb={2}
            >
              Mobile Number
            </FormLabel>
            <Input
              type="text"
              name="mobileno"
              placeholder={
                curretnInputFocous === "mobileno" ? "" : "Mobile Number"
              }
              focusBorderColor="#30d5c8"
              focusborderwidth="5px"
              transition="height 0.3s"
              fontWeight={"bold"}
              value={formData.mobileno}
              onFocus={() => setCurrentInputFocous("mobileno")}
              onBlur={() => {
                setCurrentInputFocous("");
                setDataError((prevDataError) => ({
                  ...prevDataError,
                  mobileno: formData.mobileno.trim() === "",
                }));
              }}
              isInvalid={dataError.mobileno}
              errorBorderColor="red.500"
              _placeholder={{
                fontWeight: "normal",
                color: "#0C543C",
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
              onChange={changeHandler}
            />
          </Box>
        )}
        {userType !== "expert" && (
          <>
            <Box mb={4}>
              <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Email
              </FormLabel>
              <Input
                type="email"
                name="email"
                placeholder={curretnInputFocous === "email" ? "" : "Email"}
                focusBorderColor="#30d5c8"
                focusborderwidth="5px"
                transition="height 0.3s"
                fontWeight={"bold"}
                onFocus={() => setCurrentInputFocous("email")}
                onBlur={() => {
                  setCurrentInputFocous("");
                  setDataError((prevDataError) => ({
                    ...prevDataError,
                    email: formData.email.trim() === "",
                  }));
                }}
                isInvalid={dataError.email}
                errorBorderColor="red.500"
                _placeholder={{
                  fontWeight: "normal",
                  color: "#162421",
                }}
                _focus={{
                  height: "3rem",
                  borderLeft: "5px solid #30d5c8",
                }}
                onChange={changeHandler}
              />
            </Box>

            <Box mb={4}>
              <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Password
              </FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="pswd"
                  placeholder={curretnInputFocous === "pswd" ? "" : "Password"}
                  focusBorderColor="#30d5c8"
                  focusborderwidth="5px"
                  transition="height 0.3s"
                  fontWeight={"bold"}
                  onFocus={() => setCurrentInputFocous("pswd")}
                  onBlur={() => {
                    setCurrentInputFocous("");
                    setDataError((prevDataError) => ({
                      ...prevDataError,
                      pswd: formData.pswd.trim() === "",
                    }));
                  }}
                  isInvalid={dataError.pswd}
                  errorBorderColor="red.500"
                  _placeholder={{
                    fontWeight: "normal",
                    color: "#162421",
                  }}
                  _focus={{
                    height: "3rem",
                    borderLeft: "5px solid #30d5c8",
                  }}
                  onChange={changeHandler}
                />
                <InputRightElement width="4.5rem" h={"100%"}>
                  <IconButton
                    h="1.75rem"
                    size="md"
                    onClick={() => setShowPassword(!showPassword)}
                    bg={"gray.200"}
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                  />
                </InputRightElement>
              </InputGroup>
            </Box>

            <Box mb={4}>
              <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Confirm Password
              </FormLabel>
              <Input
                type={showPassword ? "text" : "password"}
                name="cnfPswd"
                placeholder={
                  curretnInputFocous === "cnfPswd" ? "" : "Confirm Password"
                }
                focusBorderColor="#30d5c8"
                focusborderwidth="5px"
                transition="height 0.3s"
                fontWeight={"bold"}
                onFocus={() => setCurrentInputFocous("cnfPswd")}
                onBlur={() => {
                  setCurrentInputFocous("");
                  setDataError((prevDataError) => ({
                    ...prevDataError,
                    cnfPswd: formData.cnfPswd !== formData.pswd, // Example validation rule: Organization is required
                  }));
                }}
                isInvalid={formData.cnfPswd !== formData.pswd}
                errorBorderColor="red.500"
                _placeholder={{
                  fontWeight: "normal",
                  color: "#162421",
                }}
                _focus={{
                  height: "3rem",
                  borderLeft: "5px solid #30d5c8",
                }}
                onChange={changeHandler}
              />
            </Box>
            <Box textAlign={"center"}>
              <Button
                bg={"#30D5C8"}
                color={"#162421"}
                onClick={nextHandler}
                mb={4}
              >
                Next
              </Button>
            </Box>
          </>
        )}
        {userType === "expert" && (
          <ExpertRegistrationForm
            userType={userType}
            setIsSignUp={setIsSignUp}
            data={data}
            setOrgFormData={setData}
          />
        )}
      </Box>
    </>
  );
};








// const ClientRegistrationForm = ({ userType, data, setIsSignUp }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [termsAccepted, setTermsAccepted] = useState(false);
//   const [currentInputFocus, setCurrentInputFocus] = useState("");
//   const [selectedSectorCategory, setSelectedSectorCategory] = useState(null);
//   const [productOptions, setProductOptions] = useState([]);

//   const [formData, setFormData] = useState({
//     full_name: "",
//     designation: "",
//     organization: "",
//     addressLine1: "",
//     addressLine2: "",
//     pincode: "",
//     products: [],
//   });

//   const [dataError, setDataError] = useState({
//     full_name: false,
//     designation: false,
//     organization: false,
//     addressLine1: false,
//     addressLine2: false,
//     pincode: false,
//     products: false,
//   });

//   // --- Redux state ---
//   const {
//     categories = [],
//     categoriesLoading = false,
//     data: products = [],
//     loading: productsLoading = false,
//   } = useSelector((state) => state.sectorSmmReducer);

//   const { loading } = useSelector((state) => state.userReducer);

//   // --- Fetch industry categories on mount ---
//   useEffect(() => {
//     dispatch(getSectorCategories());
//   }, [dispatch]);

//   // --- Fetch products when industry changes ---
//   useEffect(() => {
//     if (selectedSectorCategory) {
//       dispatch(getAllSectors(selectedSectorCategory));
//       setFormData((prev) => ({ ...prev, products: [] }));
//       setProductOptions([]);
//     } else {
//       setProductOptions([]);
//     }
//   }, [selectedSectorCategory, dispatch]);

//   // --- Transform products for dropdown ---
//   useEffect(() => {
//     console.log("Products from Redux:", products);
    
//     if (products && products.length > 0) {
//       const formattedOptions = products.map(item => ({
//         label: item.sectorDescription,
//         value: item.sectorDescription
//       }));
//       console.log("Formatted options:", formattedOptions);
//       setProductOptions(formattedOptions);
//     } else {
//       console.log("No products found or empty array");
//       setProductOptions([]);
//     }
//   }, [products]);

//   // --- Handlers ---
//   const handleSectorCategoryChange = (e) => {
//     setSelectedSectorCategory(e.target.value);
//   };

//   const changeHandler = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleProductChange = (e) => {
//     const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
//     setFormData((prev) => ({ ...prev, products: selectedValues }));
//   };

//   const handleFormSubmit = () => {
//     if (!formData.full_name.trim()) {
//       toast.error("Please enter your full name", { position: "bottom-center" });
//       return;
//     }
//     if (!formData.designation.trim()) {
//       toast.error("Please enter your designation", { position: "bottom-center" });
//       return;
//     }
//     if (!termsAccepted) {
//       toast.error("Please accept the Terms of Service to proceed", { position: "bottom-center" });
//       return;
//     }

//     dispatch(
//       (() =>
//         userRegister(
//           {
//             ...data,
//             full_name: formData.full_name,
//             designation: formData.designation,
//             companyName: formData.organization,
//             companyAddressLine1: formData.addressLine1,
//             companyAddressLine2: formData.addressLine2,
//             companyPincode: formData.pincode,
//             userType,
//             sectorCategory: selectedSectorCategory,
//             products: formData.products,
//           },
//           navigate
//         ))()
//     );
//   };

//   return (
//     <VStack w="100%" bg="white" p={4} spacing={4} borderRadius={10}>
//       <Box>
//         <Text fontWeight={600} fontSize="16px" color="#162421" mb={4}>
//           Register to discover the smart suite of future financial tools
//         </Text>

//         {/* Full Name */}
//         <Input
//           name="full_name"
//           type="text"
//           placeholder="Your Full Name"
//           background="#F2F7F7"
//           fontWeight="bold"
//           onFocus={() => setCurrentInputFocus("full_name")}
//           onBlur={() => {
//             setCurrentInputFocus("");
//             setDataError((prev) => ({ ...prev, full_name: !formData.full_name.trim() }));
//           }}
//           isInvalid={dataError.full_name}
//           onChange={changeHandler}
//         />

//         {/* Designation */}
//         <Input
//           mt={4}
//           name="designation"
//           type="text"
//           placeholder="Your Designation"
//           background="#F2F7F7"
//           fontWeight="bold"
//           onFocus={() => setCurrentInputFocus("designation")}
//           onBlur={() => {
//             setCurrentInputFocus("");
//             setDataError((prev) => ({ ...prev, designation: !formData.designation.trim() }));
//           }}
//           isInvalid={dataError.designation}
//           onChange={changeHandler}
//         />

//         <Divider borderWidth="1px" borderColor="gray.200" mt={4} mb={4} />

//         {/* Industry Category */}
//         <Flex align="center" gap={4} mb={4}>
//           <Text>Industry Category</Text>
//           <Box flex="1">
//             {categoriesLoading ? (
//               <p>Loading categories...</p>
//             ) : (
//               <select value={selectedSectorCategory || ""} onChange={handleSectorCategoryChange}>
//                 <option value="">Select Industry</option>
//                 {categories.map((cat) => (
//                   <option key={cat} value={cat}>
//                     {cat}
//                   </option>
//                 ))}
//               </select>
//             )}
//           </Box>
//         </Flex>

       
     
// {/* Products Dropdown */}
// <Flex align="center" gap={4} mb={4}>
//   <Text>Products</Text>
//   <Box flex="1">
//     {productsLoading ? (
//       <p>Loading products...</p>
//     ) : (
//       <select
//         value={formData.products[0] || ""} // single select
//         onChange={(e) => setFormData((prev) => ({ ...prev, products: [e.target.value] }))}
//         style={{
//           width: "100%",
//           padding: "0.5rem",
//           borderRadius: "5px",
//           border: "1px solid #ccc",
//           background: "#F2F7F7",
//           appearance: "menulist", // ensures arrow shows on most browsers
//         }}
//       >
//         <option value="">Select Product</option>
//         {productOptions.length > 0 ? (
//           productOptions.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.label}
//             </option>
//           ))
//         ) : !selectedSectorCategory ? (
//           <option disabled>Please select an industry category first</option>
//         ) : (
//           <option disabled>No products available for this category</option>
//         )}
//       </select>
//     )}
//   </Box>
// </Flex>






//         {/* Organization & Address */}
//         <Heading size="sm" fontWeight={600} mt={4} mb={2}>
//           Your Organization
//         </Heading>
//         <Input name="organization" placeholder="Organization Name" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />
//         <Input name="addressLine1" placeholder="Address Line 1" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />
//         <Input name="addressLine2" placeholder="Address Line 2" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />
//         <Input name="pincode" type="number" placeholder="Pincode" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />

//         {/* Terms */}
//         <Flex align="center" mt={4} mb={4}>
//           <Checkbox colorScheme="green" onChange={() => setTermsAccepted(!termsAccepted)} />
//           <Text ml={2}>
//             I agree to the{" "}
//             <a href="https://merchant.razorpay.com/policy/M9LEThfaHp4VWn/terms" style={{ textDecoration: "underline" }}>
//               Terms of Service
//             </a>
//           </Text>
//         </Flex>

//         {/* Submit */}
//         <Box textAlign="center" mt={4}>
//           <Button bg="#30d5c8" color="white" onClick={handleFormSubmit} leftIcon={<ArrowBackIcon />}>
//             {loading ? "Wait..." : "Create Account"}
//           </Button>
//         </Box>
//       </Box>
//     </VStack>
//   );
// };



const API_PREFIX = "/api/v1/sessions/start";

/**
 * ClientRegistrationForm
 * - original form kept intact
 * - NPS modal and handlers added (no changes to original handlers)
 */
const ClientRegistrationForm = ({ userType, data, setIsSignUp }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ensure useNavigate is imported in your file scope

  const toastC = useToast();

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [currentInputFocus, setCurrentInputFocus] = useState("");
  const [selectedSectorCategory, setSelectedSectorCategory] = useState(null);
  const [productOptions, setProductOptions] = useState([]);

  const [formData, setFormData] = useState({
    full_name: "",
    designation: "",
    organization: "",
    addressLine1: "",
    addressLine2: "",
    pincode: "",
    products: [],
  });

  const [dataError, setDataError] = useState({
    full_name: false,
    designation: false,
    organization: false,
    addressLine1: false,
    addressLine2: false,
    pincode: false,
    products: false,
  });

  // --- Redux state ---
  const {
    categories = [],
    categoriesLoading = false,
    data: products = [],
    loading: productsLoading = false,
  } = useSelector((state) => state.sectorSmmReducer || {});

  const { loading } = useSelector((state) => state.userReducer || {});

  // --- Fetch industry categories on mount ---
  useEffect(() => {
    dispatch(getSectorCategories());
  }, [dispatch]);

  // --- Fetch products when industry changes ---
  useEffect(() => {
    if (selectedSectorCategory) {
      dispatch(getAllSectors(selectedSectorCategory));
      setFormData((prev) => ({ ...prev, products: [] }));
      setProductOptions([]);
    } else {
      setProductOptions([]);
    }
  }, [selectedSectorCategory, dispatch]);

  // --- Transform products for dropdown ---
  useEffect(() => {
    console.log("Products from Redux:", products);

    if (products && products.length > 0) {
      const formattedOptions = products.map((item) => ({
        label: item.sectorDescription,
        value: item.sectorDescription,
      }));
      console.log("Formatted options:", formattedOptions);
      setProductOptions(formattedOptions);
    } else {
      console.log("No products found or empty array");
      setProductOptions([]);
    }
  }, [products]);

  // --- Handlers ---
  const handleSectorCategoryChange = (e) => {
    setSelectedSectorCategory(e.target.value);
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProductChange = (e) => {
    const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
    setFormData((prev) => ({ ...prev, products: selectedValues }));
  };

  const handleFormSubmit = () => {
    if (!formData.full_name.trim()) {
      toast.error("Please enter your full name", { position: "bottom-center" });
      return;
    }
    if (!formData.designation.trim()) {
      toast.error("Please enter your designation", { position: "bottom-center" });
      return;
    }
    if (!termsAccepted) {
      toast.error("Please accept the Terms of Service to proceed", { position: "bottom-center" });
      return;
    }

    dispatch(
      (() =>
        userRegister(
          {
            ...data,
            full_name: formData.full_name,
            designation: formData.designation,
            companyName: formData.organization,
            companyAddressLine1: formData.addressLine1,
            companyAddressLine2: formData.addressLine2,
            companyPincode: formData.pincode,
            userType,
            sectorCategory: selectedSectorCategory,
            products: formData.products,
          },
          navigate
        ))()
    );

    // NOTE: integration point
    // After registration/login success you should call openNpsModal(surveyId, mainQuestion)
    // Example (do not call here immediately) -> openNpsModal("SURVEY_ID_FROM_BACKEND", "Main NPS question")
    // You can call openNpsModal in your success handler or in a useEffect that watches Redux user state.
  };

  // --------------------------
  // NPS Modal + Handlers (ADDED)
  // --------------------------
  const [showNpsModal, setShowNpsModal] = useState(false);
  const [npsSurveyId, setNpsSurveyId] = useState(null);
  const [npsMainQuestion, setNpsMainQuestion] = useState("");
  const [scoreSelecting, setScoreSelecting] = useState(null);
  const [followupQuestion, setFollowupQuestion] = useState("");
  const [followupAnswer, setFollowupAnswer] = useState("");
  const [npsLoading, setNpsLoading] = useState(false);

  // Utility: open modal with surveyId + question
  const openNpsModal = (surveyId, mainQuestion) => {
    setNpsSurveyId(surveyId || null);
    setNpsMainQuestion(mainQuestion || "On a scale from 0 to 10, how likely are you to recommend our product to a friend or colleague?");
    setScoreSelecting(null);
    setFollowupQuestion("");
    setFollowupAnswer("");
    setShowNpsModal(true);
  };

  // When a score is clicked -> call answer-score and show follow-up question from backend response
  const handleScoreClick = async (score) => {
    if (!npsSurveyId) {
      toastC({ title: "No surveyId available", status: "error", duration: 3000 });
      return;
    }
    setNpsLoading(true);
    try {
      const resp = await fetch(`${API_PREFIX}/nps/answer-score`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ surveyId: npsSurveyId, score }),
      });
      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(txt || `answer-score failed ${resp.status}`);
      }
      const json = await resp.json();
      // backend returns: { followupBucket, followupQuestion, ui... }
      setScoreSelecting(score);
      setFollowupQuestion(json.followupQuestion || json.followup_question || "");
    } catch (err) {
      console.error(err);
      toastC({ title: "Failed to submit score", description: err.message || err.toString(), status: "error", duration: 4000 });
    } finally {
      setNpsLoading(false);
    }
  };

  // Submit followup text -> calls answer-followup
  const handleFollowupSubmit = async () => {
    if (!npsSurveyId) {
      toastC({ title: "No surveyId", status: "error", duration: 2000 });
      return;
    }
    if (!followupAnswer || followupAnswer.trim().length === 0) {
      toastC({ title: "Please type an answer", status: "warning", duration: 2000 });
      return;
    }
    setNpsLoading(true);
    try {
      const resp = await fetch(`${API_PREFIX}/nps/answer-followup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ surveyId: npsSurveyId, answer: followupAnswer }),
      });
      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error(txt || `answer-followup failed ${resp.status}`);
      }
      toastC({ title: "Thanks — response saved", status: "success", duration: 2500 });
      setShowNpsModal(false);
    } catch (err) {
      console.error(err);
      toastC({ title: "Failed to submit follow-up", description: err.message || err.toString(), status: "error", duration: 4000 });
    } finally {
      setNpsLoading(false);
    }
  };

  // ---------------------------------
  // Render (your original UI unchanged)
  // ---------------------------------
  return (
    <>
      <VStack w="100%" bg="white" p={4} spacing={4} borderRadius={10}>
        <Box>
          <Text fontWeight={600} fontSize="16px" color="#162421" mb={4}>
            Register to discover the smart suite of future financial tools
          </Text>

          {/* Full Name */}
          <Input
            name="full_name"
            type="text"
            placeholder="Your Full Name"
            background="#F2F7F7"
            fontWeight="bold"
            onFocus={() => setCurrentInputFocus("full_name")}
            onBlur={() => {
              setCurrentInputFocus("");
              setDataError((prev) => ({ ...prev, full_name: !formData.full_name.trim() }));
            }}
            isInvalid={dataError.full_name}
            onChange={changeHandler}
          />

          {/* Designation */}
          <Input
            mt={4}
            name="designation"
            type="text"
            placeholder="Your Designation"
            background="#F2F7F7"
            fontWeight="bold"
            onFocus={() => setCurrentInputFocus("designation")}
            onBlur={() => {
              setCurrentInputFocus("");
              setDataError((prev) => ({ ...prev, designation: !formData.designation.trim() }));
            }}
            isInvalid={dataError.designation}
            onChange={changeHandler}
          />

          <Divider borderWidth="1px" borderColor="gray.200" mt={4} mb={4} />

          {/* Industry Category */}
          <Flex align="center" gap={4} mb={4}>
            <Text>Industry Category</Text>
            <Box flex="1">
              {categoriesLoading ? (
                <p>Loading categories...</p>
              ) : (
                <select value={selectedSectorCategory || ""} onChange={handleSectorCategoryChange}>
                  <option value="">Select Industry</option>
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              )}
            </Box>
          </Flex>

          {/* Products Dropdown */}
          <Flex align="center" gap={4} mb={4}>
            <Text>Products</Text>
            <Box flex="1">
              {productsLoading ? (
                <p>Loading products...</p>
              ) : (
                <select
                  value={formData.products[0] || ""} // single select
                  onChange={(e) => setFormData((prev) => ({ ...prev, products: [e.target.value] }))}
                  style={{
                    width: "100%",
                    padding: "0.5rem",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    background: "#F2F7F7",
                    appearance: "menulist", // ensures arrow shows on most browsers
                  }}
                >
                  <option value="">Select Product</option>
                  {productOptions.length > 0 ? (
                    productOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))
                  ) : !selectedSectorCategory ? (
                    <option disabled>Please select an industry category first</option>
                  ) : (
                    <option disabled>No products available for this category</option>
                  )}
                </select>
              )}
            </Box>
          </Flex>

          {/* Organization & Address */}
          <Heading size="sm" fontWeight={600} mt={4} mb={2}>
            Your Organization
          </Heading>
          <Input name="organization" placeholder="Organization Name" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />
          <Input name="addressLine1" placeholder="Address Line 1" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />
          <Input name="addressLine2" placeholder="Address Line 2" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />
          <Input name="pincode" type="number" placeholder="Pincode" background="#F2F7F7" mt={2} fontWeight="bold" onChange={changeHandler} />

          {/* Terms */}
          <Flex align="center" mt={4} mb={4}>
            <Checkbox colorScheme="green" onChange={() => setTermsAccepted(!termsAccepted)} />
            <Text ml={2}>
              I agree to the{" "}
              <a href="https://merchant.razorpay.com/policy/M9LEThfaHp4VWn/terms" style={{ textDecoration: "underline" }}>
                Terms of Service
              </a>
            </Text>
          </Flex>

          {/* Submit */}
          <Box textAlign="center" mt={4}>
            <Button bg="#30d5c8" color="white" onClick={handleFormSubmit} leftIcon={<ArrowBackIcon />}>
              {loading ? "Wait..." : "Create Account"}
            </Button>
          </Box>
        </Box>
      </VStack>

      {/* -----------------------
           NPS Modal (added)
         ----------------------- */}
      <Modal isOpen={showNpsModal} onClose={() => setShowNpsModal(false)} isCentered size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>NPS Survey</ModalHeader>
          <ModalBody>
            <Text fontWeight="700" mb={3}>
              {npsMainQuestion}
            </Text>

            <HStack spacing={2} wrap="wrap" mb={4}>
              {Array.from({ length: 11 }).map((_, i) => (
                <Button
                  key={i}
                  onClick={() => handleScoreClick(i)}
                  size="sm"
                  variant={scoreSelecting === i ? "solid" : "outline"}
                  colorScheme={i <= 6 ? "red" : i <= 8 ? "orange" : "green"}
                >
                  {i}
                </Button>
              ))}
            </HStack>

            {npsLoading && (
              <Box mb={2}>
                <Spinner />
              </Box>
            )}

            {scoreSelecting !== null && (
              <Box mt={4}>
                <Text fontWeight="600" mb={2}>
                  {followupQuestion || "Please share your feedback"}
                </Text>
                <Textarea placeholder="Type your feedback..." value={followupAnswer} onChange={(e) => setFollowupAnswer(e.target.value)} />
              </Box>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={() => setShowNpsModal(false)}>
              Close
            </Button>
            <Button colorScheme="teal" onClick={handleFollowupSubmit} isLoading={npsLoading} isDisabled={scoreSelecting === null}>
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

// export default ClientRegistrationForm;






const AgencyRegistrationForm = ({ userType, data, setIsSignUp }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isCA, setIsCA] = useState(true);
  const [curretnInputFocous, setCurrentInputFocous] = useState("");

  const { loading } = useSelector((state) => state.userReducer);

  const [formData, setFormData] = useState({
    full_name: "",
    designation: "",
    isCA: true,
    mrn: "",
  });

  const [dataError, setDataError] = useState({
    designation: false,
    name: false,
    avatar: false,
    mrn: false,
  });

  const changeHandler = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    setFormData({ ...formData, [name]: value });
  };

  const submitHandler = async (e) => {
    if ((formData.mrn.length === 6 && isCA) || !isCA) {
      if (termsAccepted) {
        dispatch(userRegister({ ...data, ...formData, userType }, navigate));
      } else {
        toast.error("Please agree to the Terms of Service", {
          position: "bottom-center",
          toastId: "termsAccepted",
        });
      }
    } else if (formData.mrn.length !== 6 && isCA) {
      toast.error("MRN must be of 6 digit", {
        position: "bottom-center",
        toastId: "pswd-mismatch",
      });
    }
  };

  return (
    <>
      <VStack w={"100%"} bg={"white"} p={1} spacing={4} borderRadius={10}>
        <Box>
          <Box>
            <Text fontWeight={600} fontSize={"18px"} color={"#162421"}>
              Your account details
            </Text>
          </Box>
          <Box mb={4}>
            <FormLabel
              fontWeight={400}
              fontSize={"13px"}
              textColor={"#0C543C"}
              mb={1}
            >
              Your Name
            </FormLabel>
            <Input
              name="full_name"
              type="text"
              placeholder={
                curretnInputFocous === "full_name" ? "" : "Your Full Name"
              }
              focusBorderColor="#30d5c8"
              focusborderwidth="5px"
              transition="height 0.3s"
              fontWeight={"bold"}
              onFocus={() => setCurrentInputFocous("full_name")}
              onBlur={() => {
                setCurrentInputFocous("");
                setDataError((prevDataError) => ({
                  ...prevDataError,
                  full_name: formData.full_name.trim() === "",
                }));
              }}
              isInvalid={dataError.full_name}
              errorBorderColor="red.500"
              _placeholder={{
                fontWeight: "normal",
                color: "#0C543C",
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
              onChange={changeHandler}
            />
          </Box>
          <Box mb={4}>
            <FormLabel
              fontWeight={400}
              fontSize={"13px"}
              textColor={"#0C543C"}
              mb={1}
            >
              Your designation
            </FormLabel>
            <Input
              name="designation"
              type="text"
              placeholder={
                curretnInputFocous === "designation" ? "" : "Your designation"
              }
              focusBorderColor="#30d5c8"
              focusborderwidth="5px"
              transition="height 0.3s"
              fontWeight={"bold"}
              onFocus={() => setCurrentInputFocous("designation")}
              onBlur={() => {
                setCurrentInputFocous("");
                setDataError((prevDataError) => ({
                  ...prevDataError,
                  designation: formData.designation.trim() === "",
                }));
              }}
              isInvalid={dataError.designation}
              errorBorderColor="red.500"
              _placeholder={{
                fontWeight: "normal",
                color: "#0C543C",
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
              onChange={changeHandler}
            />
          </Box>
          <Text
            fontSize={{ base: "14px", md: "16px" }}
            fontWeight="600"
            m={"15px 0px 0px 0px!important"}
            w={"92%"}
            display="flex"
            justifyContent="start"
            alignItems="start"
          >
            I am a
          </Text>
          <Box
            display="flex"
            justifyContent="start"
            alignItems="start"
            m={"5px!important"}
          >
            <Box
              textAlign="center"
              color={isCA ? "#fff" : "#0C543C"}
              cursor="pointer"
              fontSize={{ base: "14px", md: "16px" }}
              padding={{ base: "8px 10px", md: "8px 20px" }}
              backgroundColor={isCA ? "#0C543C" : "#fff"}
              borderRadius="8px 0px 0px 8px"
              border={isCA ? "1px solid #0C543C" : "1px solid #0C543C"}
              onClick={() => {
                setIsCA(true);
                setFormData({ ...formData, ["isCA"]: 1 });
              }}
            >
              CA
            </Box>
            <Box
              textAlign="center"
              padding={{ base: "8px 10px", md: "8px 20px" }}
              backgroundColor={isCA ? "#fff" : "#0C543C"}
              color={isCA ? "#0C543C" : "#fff"}
              cursor="pointer"
              borderRadius="0px 8px 8px 0px"
              fontSize={{ base: "14px", md: "16px" }}
              border={isCA ? "1px solid #0C543C" : "1px solid #0C543C"}
              onClick={() => {
                setIsCA(false);
                setFormData({ ...formData, ["isCA"]: 0 });
              }}
            >
              Other Financial Expert
            </Box>
          </Box>
          {isCA && (
            <Box mb={4}>
              <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                MRN
              </FormLabel>
              <Input
                name="mrn"
                type="number"
                placeholder={curretnInputFocous === "mrn" ? "" : "Enter MRN"}
                focusBorderColor="#30d5c8"
                focusborderwidth="5px"
                transition="height 0.3s"
                fontWeight={"bold"}
                onFocus={() => setCurrentInputFocous("mrn")}
                onBlur={() => {
                  setCurrentInputFocous("");
                  setDataError((prevDataError) => ({
                    ...prevDataError,
                    mrn: formData.mrn.trim() === "",
                  }));
                }}
                isInvalid={dataError.mrn}
                errorBorderColor="red.500"
                _placeholder={{
                  fontWeight: "normal",
                  color: "#0C543C",
                }}
                _focus={{
                  height: "3rem",
                  borderLeft: "5px solid #30d5c8",
                }}
                onChange={changeHandler}
              />
            </Box>
          )}
          <Flex>
            <Checkbox
              colorScheme="green"
              // defaultChecked
              onChange={() => setTermsAccepted(!termsAccepted)}
              sx={{
                "& input:checked + span": {
                  bg: "#0C543C",
                  "&:after": {
                    bg: "white",
                  },
                },
              }}
            />
            <Text fontWeight={500} pl={2} mt="15px">
              I have read and agree to the{" "}
              <a
                style={{ textDecoration: "underline" }}
                href="https://merchant.razorpay.com/policy/M9LEThfaHp4VWn/terms"
              >
                Terms of Service
              </a>
            </Text>
          </Flex>
          <Box textAlign={"center"}>
            <Button
              bg={"#0C543C"}
              color={"white"}
              mr={"30px"}
              onClick={() => setIsSignUp(true)}
              mb={4}
            >
              Back
            </Button>
            <Button
              bg={"#0C543C"}
              color={"white"}
              onClick={submitHandler}
              mb={4}
            >
              {loading ? "Wait..." : "Sign Up"}
            </Button>
          </Box>
        </Box>
      </VStack>
    </>
  );
};

const ExpertRegistrationForm = ({ userType, data, setOrgFormData, setIsSignUp }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isShowCaseStudy, setIsShowCaseStudy] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [curretnInputFocous, setCurrentInputFocous] = useState("");
  const { loading } = useSelector((state) => state.userReducer);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    firstName: data.firstName || "",
    lastName: data.lastName || "",
    email: data.email || "",
    password: data.password || "",
    cnfPswd: data.cnfPswd || "",
    caseStudies: data.caseStudies || [],
    schedulingLink: data.schedulingLink || "",
    agreeToTerms: data.agreeToTerms || false,
  });

  useEffect(() => {
    if (data.caseStudies) {
      setFormData((prev) => ({
        ...prev,
        caseStudies: data.caseStudies,
      }));
    }
  }, [data.caseStudies]);

  useEffect(() => {
    setFormData(data || {});
  }, [data]);


  const [dataError, setDataError] = useState({
    firstName: false,
    lastName: false,
    email: false,
    password: false,
    cnfPswd: false,
    pswd: false,
  });


  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setOrgFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };


  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.password) newErrors.password = "Password is required";
    if (formData.password !== formData.cnfPswd) {
      newErrors.cnfPswd = "Passwords do not match";
    }
    if (formData.caseStudies.length === 0) {
      newErrors.caseStudies = "All case studies must be filled";
    }
    if (!formData.schedulingLink.trim())
      newErrors.schedulingLink = "Scheduling link is required";
    if (!termsAccepted) newErrors.agreeToTerms = "You must agree to the terms";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log("Form submitted:", formData);
      dispatch(userRegister({ ...formData, userType }, navigate));
    } else if (!termsAccepted) {
      toast.error("Please agree to the Terms of Service", {
        position: "bottom-center",
        toastId: "termsAccepted",
      });
    }
  };
  console.log("====setFormData", formData);
  return (
    <>

      {isShowCaseStudy ? (
        <AddCaseStudyForm
          setOrgFormData={setOrgFormData}
          setIsShowCaseStudy={setIsShowCaseStudy}
          style={{ display: isShowCaseStudy ? "block" : "none" }}
        />
      ) : (
        <VStack w={"100%"} bg={"white"} p={1} spacing={4} borderRadius={10}>
          <Box>
            <Box mb={4}>


              {/* First Name and Last Name Row */}

              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                <div style={{ flex: 1 }}>
                  {/* <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#2d3748",
                      marginBottom: "8px",
                    }}
                  >
                    First Name *
                  </label> */}
                  <Input
                    name="firstName"
                    type="text"
                    background={"#F2F7F7"}
                    placeholder={
                      curretnInputFocous === "firstName" ? "" : "First Name"
                    }
                    focusBorderColor="#30d5c8"
                    focusborderwidth="5px"
                    transition="height 0.3s"
                    fontWeight={"bold"}
                    value={data.firstName || ""}
                    onBlur={() => {
                      setCurrentInputFocous("");
                      setDataError((prevDataError) => ({
                        ...prevDataError,
                        firstName: formData.firstName.trim() === "",
                      }));
                    }}
                    isInvalid={dataError.firstName}
                    errorBorderColor="red.500"
                    _placeholder={{
                      fontWeight: "normal",
                      color: "#162421",
                    }}
                    onFocus={() => setCurrentInputFocous("firstName")}
                    _focus={{
                      height: "3rem",
                      borderLeft: "5px solid #30d5c8",
                    }}
                    _hover={{
                      _placeholder: {
                        color: "#30d5c8",
                      },
                    }}
                    onChange={(e) =>
                      setOrgFormData((prev) => ({ ...prev, firstName: e.target.value }))
                    }

                  />
                  {errors.firstName && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#e53e3e",
                        marginTop: "4px",
                      }}
                    >
                      {errors.firstName}
                    </div>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  {/* <label
                    style={{
                      display: "block",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#2d3748",
                      marginBottom: "8px",
                    }}
                  >
                    Last Name *
                  </label> */}
                  <Input
                    name="lastName"
                    type="text"
                    placeholder={
                      curretnInputFocous === "lastName" ? "" : "Last Name"
                    }
                    background={"#F2F7F7"}
                    focusBorderColor="#30d5c8"
                    focusborderwidth="5px"
                    transition="height 0.3s"
                    fontWeight={"bold"}
                    value={data.lastName || ""}
                    onBlur={() => {
                      setCurrentInputFocous("");
                      setDataError((prevDataError) => ({
                        ...prevDataError,
                        lastName: formData.lastName.trim() === "",
                      }));
                    }}
                    isInvalid={dataError.lastName}
                    errorBorderColor="red.500"
                    _placeholder={{
                      fontWeight: "normal",
                      color: "#162421",
                    }}
                    onFocus={() => setCurrentInputFocous("lastName")}
                    _focus={{
                      height: "3rem",
                      borderLeft: "5px solid #30d5c8",
                    }}
                    _hover={{
                      _placeholder: {
                        color: "#30d5c8",
                      },
                    }}
                    onChange={(e) =>
                      setOrgFormData((prev) => ({ ...prev, lastName: e.target.value }))
                    }
                  />
                  {errors.lastName && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#e53e3e",
                        marginTop: "4px",
                      }}
                    >
                      {errors.lastName}
                    </div>
                  )}
                </div>
              </div>
            </Box>

            <Box mb={4}>
              {/* <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Email
              </FormLabel> */}
              <Input
                type="email"
                name="email"
                background={"#F2F7F7"}
                placeholder={curretnInputFocous === "email" ? "" : "Email"}
                focusBorderColor="#30d5c8"
                focusborderwidth="5px"
                transition="height 0.3s"
                fontWeight={"bold"}
                value={data.email || ""}
                onFocus={() => setCurrentInputFocous("email")}
                onBlur={() => {
                  setCurrentInputFocous("");
                  setDataError((prevDataError) => ({
                    ...prevDataError,
                    email: formData.email.trim() === "",
                  }));
                }}
                isInvalid={dataError.email}
                errorBorderColor="red.500"
                _placeholder={{
                  fontWeight: "normal",
                  color: "#0C543C",
                }}
                _focus={{
                  height: "3rem",
                  borderLeft: "5px solid #30d5c8",
                }}
                _hover={{
                  _placeholder: {
                    color: "#30d5c8",
                  },
                }}
                onChange={(e) =>
                  setOrgFormData((prev) => ({ ...prev, email: e.target.value }))
                }
              />
              {errors.email && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#e53e3e",
                    marginTop: "4px",
                  }}
                >
                  {errors.email}
                </div>
              )}
            </Box>

            <Box mb={4}>
              {/* <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Password
              </FormLabel> */}
              <InputGroup>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  background={"#F2F7F7"}
                  placeholder={
                    curretnInputFocous === "password" ? "" : "Password"
                  }
                  focusBorderColor="#30d5c8"
                  focusborderwidth="5px"
                  transition="height 0.3s"
                  fontWeight={"bold"}
                  value={data.password || ""}
                  onFocus={() => setCurrentInputFocous("password")}
                  onBlur={() => {
                    setCurrentInputFocous("");
                    setDataError((prevDataError) => ({
                      ...prevDataError,
                      password: formData.password.trim() === "",
                    }));
                  }}
                  isInvalid={dataError.password}
                  errorBorderColor="red.500"
                  _placeholder={{
                    fontWeight: "normal",
                    color: "#0C543C",
                  }}
                  _focus={{
                    height: "3rem",
                    borderLeft: "5px solid #30d5c8",
                  }}
                  _hover={{
                    _placeholder: {
                      color: "#30d5c8",
                    },
                  }}
                  onChange={(e) =>
                    setOrgFormData((prev) => ({ ...prev, password: e.target.value }))
                  }
                />
                <InputRightElement width="4.5rem" h={"100%"}>
                  <IconButton
                    h="1.75rem"
                    size="md"
                    color={"#30D5C8"}
                    onClick={() => setShowPassword(!showPassword)}
                    bg={"fff"}
                    icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                  />
                </InputRightElement>
              </InputGroup>
              {errors.password && (
                <div
                  style={{
                    fontSize: "12px",
                    color: "#e53e3e",
                    marginTop: "4px",
                  }}
                >
                  {errors.password}
                </div>
              )}
            </Box>

            <Box mb={4}>
              {/* <FormLabel
                fontWeight={400}
                fontSize={"13px"}
                textColor={"#0C543C"}
                mb={1}
              >
                Confirm Password
              </FormLabel> */}
              <Input
                type={showPassword ? "text" : "password"}
                name="cnfPswd"
                background={"#F2F7F7"}
                placeholder={
                  curretnInputFocous === "cnfPswd" ? "" : "Confirm Password"
                }
                focusBorderColor="#30d5c8"
                focusborderwidth="5px"
                transition="height 0.3s"
                fontWeight={"bold"}
                value={data.cnfPswd || ""}
                onFocus={() => setCurrentInputFocous("cnfPswd")}
                onBlur={() => {
                  setCurrentInputFocous("");
                  setDataError((prevDataError) => ({
                    ...prevDataError,
                    cnfPswd: formData.cnfPswd !== formData.password, // Example validation rule: Organization is required
                  }));
                }}
                isInvalid={formData.cnfPswd !== formData.password}
                errorBorderColor="red.500"
                _placeholder={{
                  fontWeight: "normal",
                  color: "#0C543C",
                }}
                _focus={{
                  height: "3rem",
                  borderLeft: "5px solid #30d5c8",
                }}
                _hover={{
                  _placeholder: {
                    color: "#30d5c8",
                  },
                }}
                onChange={(e) =>
                  setOrgFormData((prev) => ({ ...prev, cnfPswd: e.target.value }))
                }
              />
            </Box>

            <Box mb={4}>
              {/* Case Studies */}
              <div style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginBottom: "16px",
                    paddingRight: "4px",
                  }}
                >
                  <div style={{ marginRight: "10px" }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#2d3748",
                        lineHeight: "1.2",
                        marginBottom: "2px",
                      }}
                    >
                      Add Case Studies *
                    </div>
                    <Flex
                      style={{
                        fontSize: "12px",
                        color: "#718096",
                        lineHeight: "1.2",
                      }}
                    >
                      (Minimum 1 required)
                    </Flex>
                  </div>
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#30D5C8",
                      borderRadius: "10px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "18px",
                      fontWeight: "300",
                      color: "#fff",
                      transition: "all 0.15s",
                      flexShrink: 0,
                      marginTop: "2px",
                    }}
                    onClick={() => {
                      setErrors({ ...errors, caseStudies: "" });
                      setIsShowCaseStudy(true);
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.borderColor = "#9ca3af";
                      e.target.style.color = "#4b5563";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.color = "#6b7280";
                    }}
                  >
                    <div
                      style={{
                        width: "30px",
                        height: "30px",
                        backgroundColor: "#30D5C8",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "39px",
                        fontWeight: "400",
                        marginTop: "2px",
                      }}
                    >
                      +
                    </div>
                  </div>
                </div>

                {formData?.caseStudies &&
                  formData.caseStudies.map((caseStudy, index) => (
                    <div key={index} style={{ marginBottom: "12px" }}>
                      {index + 1}: {caseStudy.metric}
                    </div>
                  ))}

                {errors?.caseStudies && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#e53e3e",
                      marginTop: "4px",
                    }}
                  >
                    Add atleast 1 use case study.{errors.caseStudies}
                  </div>
                )}
              </div>

              {/* Scheduling Link */}
              <div style={{ marginBottom: "24px" }}>
                {/* <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#2d3748",
                    marginBottom: "8px",
                  }}
                >
                  Share your Google Booking / Calendly Scheduling Link *
                </label> */}
                <input
                  type="url"
                  name="schedulingLink"
                  value={formData.schedulingLink}
                  placeholder={
                    curretnInputFocous === "schedulingLink" ? "" : "Share your Google Booking / Calendly Scheduling Link *"
                  }


                  onChange={changeHandler}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "1px solid #e2e8f0",
                    borderRadius: "6px",
                    fontSize: "14px",
                    color: "#000",
                    backgroundColor: "#f7fafc",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
                {errors.schedulingLink && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#e53e3e",
                      marginTop: "4px",
                    }}
                  >
                    {errors.schedulingLink}
                  </div>
                )}
              </div>
            </Box>

            <Flex>
              <Checkbox
                colorScheme="green"
                // defaultChecked
                onChange={() => setTermsAccepted(!termsAccepted)}
                sx={{
                  "& input:checked + span": {
                    bg: "#0C543C",
                    "&:after": {
                      bg: "white",
                    },
                  },
                }}
              />
              <Text pl={2} mt="5px" fontSize={15}>
                I have read and agree to the{" "}
                <a
                  style={{ borderBottom: "3px solid #30D5C8", fontWeight: 500 }}
                  href="https://merchant.razorpay.com/policy/M9LEThfaHp4VWn/terms"
                >
                  Terms of Service
                </a>
              </Text>
            </Flex>
            <Flex justifyContent={"space-around"} marginTop={"10px"}>
              {/* <Button
              bg={"#0C543C"}
              color={"white"}
              mr={"30px"}
              onClick={() => setIsSignUp(true)}
              mb={4}
            >
              Back
            </Button> */}
              <Button
                bg={"#30d5c8"}
                color={"white"}
                onClick={submitHandler}
                mb={4}
                mt={4}
                leftIcon={<ArrowBackIcon />}
              >
                {loading ? "Wait..." : "Create Account"}
              </Button>

            </Flex>
          </Box>
        </VStack>
      )}
    </>
  );
};

const AddCaseStudyForm = ({
  setOrgFormData,
  setIsShowCaseStudy,
  setIsSignUp,
}) => {
  const [selectedIndustry, setSelectedIndustry] = useState(
    "Food And Kindred Products"
  );
  const [timeUnit, setTimeUnit] = useState("Month(s)");
  const [feeUnit, setFeeUnit] = useState("Thousands");
  const [feeRange, setFeeRange] = useState([25000, 75000]);
  
  const sliderContainerStyle = { marginBottom: "20px" };

  const rangeInputsStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
  };
  const unitButtonStyle = (isActive) => ({
    padding: "6px 12px",
    marginRight: "8px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: isActive ? "#4a5568" : "#fff",
    color: isActive ? "#fff" : "#333",
    cursor: "pointer",
    fontSize: "12px",
  });

  const [selectedMetric, setSelectedMetric] = useState("Revenue Growth");
  const [selectedSectorCategory, setSelectedSectorCategory] = useState(null);
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const [showAllIndustries, setShowAllIndustries] = useState(false);
  const { data: sectorPopularData = [], loading } = useSelector(
    (state) => state.sectorPopularReducer
  );
  const allIndustries = sectorPopularData.map((sector) => ({
    id: sector._id,
    sectorName: sector.sectorName,
  }));
  const basicIndustries = allIndustries.slice(0, 4);
  
  const industries = showAllIndustries ? allIndustries : basicIndustries;
  const [errors, setErrors] = useState({
    caseStudyTitle: "",
    industry: "",
    role: "",
    metric: "",
    actionTaken: "",
    results: "",
  });
  const [formData, setFormData] = useState({
    caseStudyTitle: "",
    industry: "",
    role: "",
    metric: "Revenue Growth",
    actionTaken: "",
    results: "",
    // (not touching anything else per your request;
    // 'products' will be added by the dropdown handler)
  });
  const metrics = [
    "Revenue Growth",
    "Relative Market Share",
    "EBITDA% ",
    "ROE",
    "Fixed Asset Turnover Ratio",
    "Current Ratio",
    "DRO",
    "DIO",
    "Employees % ",
    "Materials % ",
  ];

  const functionRoles = {
    "Finance": [
      "Fractional CFO",
      "Working Capital Analyst",
      "AR Process Auditor",
      "AP Process Consultant",
      "Inventory Cost Controller",
      "Costing Specialist",
      "ERP Integration Coach",
      "Internal Audit Lead (Interim)",
      "Tax Optimization Expert",
      "Financial Modeller",
      "Loan Restructuring Advisor",
      "Compliance Auditor",
      "Procurement Finance Partner",
      "Fixed Asset Specialist",
      "Treasury Trainer",
      "Credit Risk Analyst",
      "Shared Services Consultant",
      "ESG Compliance Lead",
      "Budget Control Coach",
      "Vendor Finance Advisor",
      "Pricing Strategy Expert",
      "Statutory Reporting Consultant",
      "Cash Conversion Cycle Coach",
      "Finance Process Trainer",
      "Business Finance Partner"
    ],
    "Operations": [
      "Lean Manufacturing Coach",
      "Inventory Optimization Consultant",
      "Process Efficiency Auditor",
      "Quality Management Trainer",
      "Plant Layout Engineer",
      "Capacity Planning Advisor",
      "TPM (Total Productive Maintenance) Consultant",
      "Production Scheduler",
      "Shop Floor Digitalization Expert",
      "Safety Compliance Trainer",
      "OEE Analyst (Overall Equip Effectiveness)",
      "Bottleneck Identification Specialist",
      "Vendor Quality Consultant",
      "Production KPI Coach",
      "Root Cause Analysis Expert",
      "Contract Manufacturing Advisor",
      "Asset Utilization Analyst",
      "Batch Process Optimization Consultant",
      "Energy Efficiency Consultant",
      "Logistics & Inbound Coordinator",
      "Packaging Cost Engineer",
      "Preventive Maintenance Trainer",
      "Outsourced Ops Reviewer",
      "Shift Efficiency Analyst",
      "Waste Reduction Consultant"
    ],
    "Sales": [
      "Regional Sales Coach",
      "Distributor Margin Analyst",
      "Channel Conflict Mediator",
      "Trade Promotion Auditor",
      "Sales Forecasting Consultant",
      "Pricing Analytics Trainer",
      "Territory Planning Expert",
      "Key Account Development Coach",
      "Sales Process Auditor",
      "B2B Lead Qualification Consultant",
      "Sales Incentive Design Specialist",
      "Retail Channel Strategy Advisor",
      "Sales CRM Consultant",
      "Conversion Funnel Analyst",
      "Product-Market Fit Reviewer",
      "Export Market Advisor",
      "Online Sales Channel Consultant",
      "Field Sales Productivity Auditor",
      "Competitive Pricing Strategist",
      "Demand Generation Partner",
      "Retailer Training Lead",
      "GTM (Go-to-Market) Strategist",
      "Sales SOP Designer",
      "Distributor Financing Consultant",
      "Sales Capability Trainer"
    ],
    "Human Resources": [
      "Workforce Planning Specialist",
      "Recruitment Efficiency Analyst",
      "Onboarding Process Designer",
      "Performance Management Consultant",
      "Skill Gap Mapping Expert",
      "Employee Engagement Coach",
      "Industrial Relations Consultant",
      "HR Cost Rationalization Advisor",
      "Payroll Compliance Auditor",
      "L&D Program Developer",
      "Compensation Benchmarking Consultant",
      "HRMS Implementation Advisor",
      "Freelance & Gig Talent Strategist",
      "Culture Building Facilitator",
      "Leadership Pipeline Coach",
      "Union Negotiation Partner",
      "Shopfloor HR Coordinator",
      "Workplace Safety & Welfare Consultant",
      "Role Redesign Expert",
      "Incentive Program Designer",
      "Attendance & Leave Policy Auditor",
      "HR Analytics Specialist",
      "Internal Communications Advisor",
      "Remote/Hybrid Work Consultant",
      "HRBP (HR Business Partner) Coach"
    ],
    "Cross-Functional Innovation": [
      "Business Transformation Advisor",
      "Process Innovation Facilitator",
      "Cross-Functional KPI Designer",
      "Digital Maturity Assessor",
      "AI Readiness Consultant",
      "Data Strategy Architect",
      "Cross-Unit Cost Reduction Partner",
      "Innovation Funnel Coach",
      "Customer Experience Designer",
      "Strategic Initiative PMO Lead",
      "Lean-Agile Coach",
      "ESG Strategy Partner",
      "Enterprise Architecture Advisor",
      "Digital Twin Consultant",
      "Innovation Culture Facilitator",
      "Working Capital Program Manager",
      "Product Lifecycle Auditor",
      "Zero-Based Budgeting Lead",
      "Service Design Consultant",
      "Cross-Dept Training Designer",
      "Industry 4.0 Roadmap Consultant",
      "Organizational Health Auditor",
      "Customer Profitability Analyst",
      "Joint Metrics Reviewer",
      "Continuous Improvement Lead"
    ]
  };
  const handleFunctionSelect = (selectedFunction) => {
    setFormData({ ...formData, function: selectedFunction, role: "" });
    setIsFunctionDropdownOpen(false);
    setIsRoleDropdownOpen(false);
  };

  const [isFunctionDropdownOpen, setIsFunctionDropdownOpen] = useState(false);

  const containerStyle = {
    padding: "20px",
  };

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "10px",
    borderBottom: "1px solid #e0e0e0",
  };

  const titleStyle = {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
  };

  const closeButtonStyle = {
    background: "none",
    border: "none",
    fontSize: "24px",
    color: "#999",
    cursor: "pointer",
    padding: "0",
  };

  const sectionStyle = {
    marginBottom: "20px",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  };

  const industryGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "8px",
    marginBottom: "10px",
  };

  const industryButtonStyle = (isSelected) => ({
    padding: "4px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: isSelected ? "#4a5568" : "#fff",
    color: isSelected ? "#fff" : "#333",
    cursor: "pointer",
    fontSize: "12px",
    textAlign: "left",
    transition: "all 0.2s ease",
  });

  const showAllLinkStyle = {
    color: "#4a5568",
    textDecoration: "none",
    fontSize: "12px",
    fontWeight: "500",
  };

  const dropdownContainerStyle = {
    position: "relative",
    marginBottom: "20px",
  };

  const dropdownButtonStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#fff",
    cursor: "pointer",
    textAlign: "left",
    fontSize: "14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const dropdownListStyle = {
    position: "absolute",
    top: "100%",
    left: "0",
    right: "0",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "4px",
    maxHeight: "200px",
    overflowY: "auto",
    zIndex: 1000,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  const dropdownItemStyle = {
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    borderBottom: "1px solid " + "#f0f0f0",
  };

  const metricGridStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "10px",
  };

  const metricButtonStyle = (isSelected) => ({
    padding: "4px 12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: isSelected ? "#4a5568" : "#fff",
    color: isSelected ? "#fff" : "#333",
    cursor: "pointer",
    fontSize: "12px",
    textAlign: "center",
    transition: "all 0.2s ease",
  });

  const inputStyle = {
    width: "100%",
    minHeight: "40px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    resize: "vertical",
    fontFamily: "inherit",
  };
  const rangeLabelsStyle = {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
    fontSize: "12px",
    color: "#666",
  };

  const rangeInputStyle = {
    width: "80px",
    padding: "6px 8px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    marginLeft: "8px",
  };

  const textareaStyle = {
    width: "100%",
    minHeight: "80px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "14px",
    resize: "vertical",
    fontFamily: "inherit",
  };

  const saveButtonStyle = {
    width: "100%",
    padding: "12px",
    backgroundColor: "#4a5568",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    marginTop: "20px",
  };

  const errorStyle = {
    fontSize: "16px",
    color: "red",
  };
  const selectTextStyle = {
  fontSize: 12,
  color: "#2B2F36",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "hidden",
};

const chevronStyle = {
  width: 10,
  height: 10,
  borderRight: "2px solid #1CC3B2",
  borderBottom: "2px solid #1CC3B2",
  transform: "rotate(45deg)",
  marginLeft: 12,
};
const resultsBoxStyle = {
  marginTop: 8,
  background: "#F2F5F7",
  borderRadius: 8,
  padding: "12px 14px",
  color: "#2B2F36",
  fontSize: 13,
};
const selectBoxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "1px solid #E3E8EE",
  background: "#F7FAFC",
  borderRadius: 5,
  height: 40,
  padding: "0 10px",
  position: "relative",
};
const rowStyle = {
  display: "grid",
  gridTemplateColumns: "100px 1fr",
  alignItems: "center",
  gap: 16,
};

const fieldLabelStyle = {
  fontSize: 13,
  color: "#2B2F36",
  background: "#F2F5F7",
  display: "flex",
  alignItems: "center",   
  justifyContent: "center", 
  height: "44px",          
  borderRadius: "8px",     
  fontWeight: 500          
};


  const validateForm = () => {
    const newErrors = {};

    if (!formData.caseStudyTitle.trim()) {
      newErrors.caseStudyTitle = "Please enter case study title";
    }

    if (!formData.industry.trim()) {
      newErrors.industry = "Please select your industry";
    }

    if (!formData.role.trim()) {
      newErrors.role = "Please select your role";
    }

    if (!formData.actionTaken.trim()) {
      newErrors.actionTaken = "Action taken is required";
    }

    if (!formData.results.trim()) {
      newErrors.results = "Results description is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleIndustrySelect = (industry) => {
    setFormData({ ...formData, industry: industry.id });
    setSelectedIndustry(industry.id);
    if (errors.industry) {
      setErrors({ ...errors, industry: "" });
    }
  };

  const handleRoleSelect = (role) => {
    setFormData({ ...formData, role });
    setIsRoleDropdownOpen(false);
    if (errors.role) {
      setErrors({ ...errors, role: "" });
    }
  };

  const handleMetricSelect = (metric) => {
    setFormData({ ...formData, metric });
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: "" });
    }
  };

  const handleSave = () => {
    if (validateForm()) {
      console.log("Form Data:", formData);

      const newCaseStudyObj = {
        caseStudyTitle: formData.caseStudyTitle,
        industry: formData.industry,
        role: formData.role,
        metric: formData.metric,
        actionTaken: formData.actionTaken,
        result: formData.result,
      };

      setOrgFormData((prev) => ({
        ...prev,
        caseStudies: [...(prev.caseStudies ?? []), newCaseStudyObj],
      }));

      setIsShowCaseStudy(false);
      // setIsSignUp(true);
    }
  };

  const dispatch = useDispatch();

  // Redux sector data
  const { loading: categoriesLoading, data: sectorData } = useSelector(
    (state) => state.sectorReducer
  );

  // Fetch categories on mount
  // useEffect(() => {
  //   dispatch(getSectorsCategories());
  // }, [dispatch]);

  // Fetch products for dropdown
  const fetchProductsForDropdown = async (category) => {
    const response = await getSectorCategoryProductsApi(category);
    dispatch({
      type: "SET_PRODUCT_MASTER_LIST",
      payload: response.data,
    });
    localStorage.setItem("productMasterList", JSON.stringify(response.data));
    return response;
  };

  const handleSectorCategoryChange = (opt) => {
    setSelectedSectorCategory(opt?.value);
  };
  const sectorCategories = sectorData?.data ?? [];

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h2 style={titleStyle}>Add Case Study</h2>
        <button
          style={closeButtonStyle}
          onClick={() => {
            setIsShowCaseStudy(false);
            // setIsSignUp(true);
          }}
        >
          ×
        </button>
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>Case Study Title *</label>
        <input
          style={inputStyle}
          value={formData.caseStudyTitle}
          onChange={(e) => handleInputChange("caseStudyTitle", e.target.value)}
          placeholder="Please enter case study title."
        />
        {errors.caseStudyTitle && (
          <p style={errorStyle}>{errors.caseStudyTitle}</p>
        )}
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>Select your industry of expertise</label>
        <div style={industryGridStyle}>
          {industries.map((industry) => {
            const Icon = SECTOR_ICONS[industry.sectorName];
            console.log("=====Icon", Icon, industry.sectorName);
            return (
              <button
                key={industry.id}
                style={industryButtonStyle(selectedIndustry === industry.id)}
                onClick={() => handleIndustrySelect(industry)}
              >
                <Flex>
                  {Icon && (
                    <div
                      style={{
                        marginRight: "5px",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Icon width={15} height={15} />
                    </div>
                  )}
                  <div>{industry.sectorName}</div>
                </Flex>
              </button>
            );
          })}
        </div>
        <a
          href="#"
          style={showAllLinkStyle}
          onClick={(e) => {
            e.preventDefault();
            setShowAllIndustries(!showAllIndustries);
          }}
        >
          {showAllIndustries ? "Show Less" : "Show All"}
        </a>
        {errors.industry && <p style={errorStyle}>{errors.industry}</p>}
      </div>

      {/* Industry Category */}
      <HStack
        flexWrap="wrap"
        spacing={{ base: 4, md: 8 }}
        width={{ base: "100%", md: "auto" }}
        mb={4}
      >
        <Text
          width={{ base: "100%", md: "8rem" }}
          textAlign={"left"}
          whiteSpace="nowrap"
          ml={"4px"}
        >
          Industry Category
        </Text>

        <Box
          width={{ base: "100%", md: "27rem" }}
          pt={{ base: 2, md: "0" }}
        >
          {categoriesLoading ? (
            <p>Loading categories...</p>
          ) : (
            <SectorCategoriesDropdown
              sectorCategories={sectorData?.data}
              selectedSectorCategory={selectedSectorCategory}
              handleSectorCategoryChange={handleSectorCategoryChange}
            />
            
          )}
          
        </Box>
      </HStack>

      {/* Product (UPDATED ONLY THIS BLOCK) */}
      {selectedSectorCategory && (
        <Flex
          width={{ base: "100%", md: "auto" }}
          wrap={"wrap"}
          alignItems={"flex-start"}
          direction={{ base: "column", md: "row" }}
          justifyContent={{ base: "flex-start", md: "space-between" }}
        >
          <Text
            width={{ base: "100%", md: "9rem" }}
            pt={{ base: "1rem", md: "0" }}
            textAlign={"left"}
            ml={{ base: "0", md: "10px" }}
          >
            Product
          </Text>

          <Box w={{ base: "100%", md: "21rem" }}>
            <Text fontSize={"14px"} fontWeight={500}>
              {(formData?.products?.length ?? 0) === 0
                ? "Minimum 3 required/Maximum 20 available"
                : (formData?.products?.length ?? 0) < 3
                ? "Minimum 3 required"
                : "Maximum 20 available"}
            </Text>
            <ProductsDropdown
              selectedSectorCategory={selectedSectorCategory}
              fetchDataFunction={fetchProductsForDropdown}
              placeholder="Search Products..."
              isMulti
              handleOptionChange={(selectedOptions) => {
                const options = Array.isArray(selectedOptions)
                  ? selectedOptions
                  : [];
                const products = options
                  .map((val) => val?.value)
                  .filter(Boolean)
                  .slice(0, 20); // cap at 20

                // update state without reading formData.products.length
                setFormData((prev) => ({
                  ...prev,
                  products,
                }));

                dispatch({
                  type: "SET_SELECTED_PRODUCTS",
                  payload: products,
                  meta: { source: "register" },
                });

                localStorage.setItem(
                  "selectedProducts",
                  JSON.stringify(products)
                );
              }}
              _focus={{
                height: "3rem",
                borderLeft: "5px solid #30d5c8",
              }}
            />
          </Box>
        </Flex>
      )}

      <div>
        {/* Function Dropdown */}
        <div style={sectionStyle}>
          <label style={labelStyle}>Function</label>
          <div style={dropdownContainerStyle}>
            <button
              style={dropdownButtonStyle}
              onClick={() => setIsFunctionDropdownOpen(!isFunctionDropdownOpen)}
            >
              <span>{formData.function || "Select a function"}</span>
             <span style={chevronStyle} />
            </button>
            {isFunctionDropdownOpen && (
              <div style={dropdownListStyle}>
                {Object.keys(functionRoles).map((func) => (
                  <div
                    key={func}
                    style={dropdownItemStyle}
                    onClick={() => handleFunctionSelect(func)}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
                  >
                    {func}
                  </div>
                ))}
              </div>
            )}
          </div>
          {errors.function && <p style={errorStyle}>{errors.function}</p>}
        </div>

        {/* Role Dropdown */}
        {formData.function && (
          <div style={sectionStyle}>
            <label style={labelStyle}>Role</label>
            <div style={dropdownContainerStyle}>
              <button
                style={dropdownButtonStyle}
                onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
              >
                <span>{formData.role || "Select your role"}</span>
                <span style={chevronStyle} />
              </button>
              {isRoleDropdownOpen && (
                <div style={dropdownListStyle}>
                  {functionRoles[formData.function].map((role) => (
                    <div
                      key={role}
                      style={dropdownItemStyle}
                      onClick={() => handleRoleSelect(role)}
                      onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
                      onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
                    >
                      {role}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {errors.role && <p style={errorStyle}>{errors.role}</p>}
          </div>
        )}
      </div>

      {/* Formula */}
     <div style={sectionStyle}>
  <label style={labelStyle}>ENTER THE FORMULA YOU CONTRIBUTED TO</label>

  {/* Metric row */}
  <div style={rowStyle}>
    <div style={fieldLabelStyle}>Metric</div>

    <div style={selectBoxStyle}>
      <span style={selectTextStyle}>
        Total Revenue from Operations of current period
      </span>
      <span style={chevronStyle} />
    </div>
  </div>

  {/* Results box */}
  <div style={resultsBoxStyle}>Results</div>
</div>


      <div style={sectionStyle}>
        <label style={labelStyle}>Choose Metric Improved *</label>
        <div style={metricGridStyle}>
          {metrics.map((metric) => (
            <button
              key={metric}
              style={metricButtonStyle(formData.metric === metric)}
              onClick={() => handleMetricSelect(metric)}
            >
              {metric}
            </button>
          ))}
        </div>
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>Action Taken *</label>
        <textarea
          style={textareaStyle}
          value={formData.actionTaken}
          onChange={(e) => handleInputChange("actionTaken", e.target.value)}
          placeholder="Describe the actions you took..."
        />
        {errors.actionTaken && <p style={errorStyle}>{errors.actionTaken}</p>}
      </div>

      <div style={sectionStyle}>
        <label style={labelStyle}>Results *</label>
        <textarea
          style={textareaStyle}
          value={formData.results}
          onChange={(e) => handleInputChange("results", e.target.value)}
          placeholder="Describe the results achieved..."
        />
        {errors.results && <p style={errorStyle}>{errors.results}</p>}
      </div>

      <div
        style={{
          ...sliderContainerStyle,
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: "16px",
          alignItems: "start",
        }}
      >
        <label style={labelStyle}>
          Approximate assignment fee borne by client
        </label>
        <div style={{ ...rangeLabelsStyle, gridColumn: "2" }}>
          <span>25</span>
          <span>50</span>
          <span>75</span>
          <span>100</span>
        </div>

        <div style={{ position: "relative", marginBottom: "15px", gridColumn: "2" }}>
          <div
            style={{
              height: "6px",
              background: "#e0e0e0",
              borderRadius: "3px",
              position: "relative",
              marginBottom: "30px",
            }}
          >
            <div
              style={{
                position: "absolute",
                left: `${((feeRange[0] / 1000 - 10) / 90) * 100}%`,
                width: `${((feeRange[1] / 1000 - feeRange[0] / 1000) / 90) * 100}%`,
                height: "100%",
                background: "#4a5568",
                borderRadius: "3px",
              }}
            ></div>
            <div
              style={{
                position: "absolute",
                left: `${((feeRange[0] / 1000 - 10) / 90) * 100}%`,
                top: "-8px",
                width: "16px",
                height: "16px",
                background: "#4a5568",
                borderRadius: "50%",
                border: "2px solid #fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                cursor: "pointer",
                zIndex: "10",
                transform: "translateX(-50%)",
              }}
              onMouseDown={(e) => {
                const rect = e.currentTarget.parentElement.getBoundingClientRect();
                const handleMouseMove = (e) => {
                  const x = e.clientX - rect.left;
                  const percentage = Math.max(
                    0,
                    Math.min(100, (x / rect.width) * 100)
                  );
                  const value = Math.round(10 + (percentage / 100) * 90);
                  if (value * 1000 <= feeRange[1]) {
                    setFeeRange([value * 1000, feeRange[1]]);
                  }
                };
                const handleMouseUp = () => {
                  document.removeEventListener("mousemove", handleMouseMove);
                  document.removeEventListener("mouseup", handleMouseUp);
                };
                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
              }}
            />
            <div
              style={{
                position: "absolute",
                left: `${((feeRange[1] / 1000 - 10) / 90) * 100}%`,
                top: "-8px",
                width: "16px",
                height: "16px",
                background: "#4a5568",
                borderRadius: "50%",
                border: "2px solid #fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                cursor: "pointer",
                zIndex: "10",
                transform: "translateX(-50%)",
              }}
              onMouseDown={(e) => {
                const rect = e.currentTarget.parentElement.getBoundingClientRect();
                const handleMouseMove = (e) => {
                  const x = e.clientX - rect.left;
                  const percentage = Math.max(
                    0,
                    Math.min(100, (x / rect.width) * 100)
                  );
                  const value = Math.round(10 + (percentage / 100) * 90);
                  if (value * 1000 >= feeRange[0]) {
                    setFeeRange([feeRange[0], value * 1000]);
                  }
                };
                const handleMouseUp = () => {
                  document.removeEventListener("mousemove", handleMouseMove);
                  document.removeEventListener("mouseup", handleMouseUp);
                };
                document.addEventListener("mousemove", handleMouseMove);
                document.addEventListener("mouseup", handleMouseUp);
              }}
            />
          </div>
        </div>

        {/* LEFT SIDE (Thousands / Lacs buttons) */}
        <div style={{ marginTop: "10px", gridColumn: "1" }}>
          <button
            style={unitButtonStyle(feeUnit === "Thousands")}
            onClick={() => setFeeUnit("Thousands")}
          >
            Thousands
          </button>
          <button
            style={unitButtonStyle(feeUnit === "Lacs")}
            onClick={() => setFeeUnit("Lacs")}
          >
            Lacs
          </button>
        </div>

        {/* RIGHT SIDE (From / To inputs) */}
        <div style={{ ...rangeInputsStyle, gridColumn: "2", marginTop: "10px" }}>
          <div>
            <span style={{ fontSize: "12px", color: "#666" }}>From</span>
            <input
              type="number"
              style={rangeInputStyle}
              value={feeRange[0]}
              onChange={(e) =>
                setFeeRange([parseInt(e.target.value) || 0, feeRange[1]])
              }
            />
          </div>
          <div>
            <span style={{ fontSize: "12px", color: "#666" }}>To</span>
            <input
              type="number"
              style={rangeInputStyle}
              value={feeRange[1]}
              onChange={(e) =>
                setFeeRange([feeRange[0], parseInt(e.target.value) || 0])
              }
            />
          </div>
        </div>
      </div>

      <div
        style={{
          ...sectionStyle,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <label style={labelStyle}>Estimated time to impact</label>
        <div>
          <button
            style={unitButtonStyle(timeUnit === "Month(s)")}
            onClick={() => setTimeUnit("Month(s)")}
          >
            Month(s)
          </button>
          <button
            style={unitButtonStyle(timeUnit === "Year(s)")}
            onClick={() => setTimeUnit("Year(s)")}
          >
            Year(s)
          </button>
        </div>
      </div>

      <button style={saveButtonStyle} onClick={handleSave}>
        Save Case Study
      </button>
    </div>
  );
};




